import React from "react";
import { connect } from "react-redux";
import jwt from "jwt-decode";
import { logout } from "../../lib/providers/auth-provider/actions";
import { markSessionExpired, sessionExpiryTimeoutMs } from "../../utils/sessionExpiry";

/**
 * Logs out when the session JWT reaches its exp claim.
 */
class SessionExpiryWatcher extends React.Component {
  timer = null;

  componentDidMount() {
    this.arm();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.token !== this.props.token) {
      this.arm();
    }
  }

  componentWillUnmount() {
    this.clear();
  }

  clear = () => {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  };

  /**
   * Starts a timer for the current token's exp.
   * @returns {void}
   */
  arm = () => {
    this.clear();
    if (!this.props.token) {
      return;
    }
    try {
      const { exp } = jwt(this.props.token);
      if (!exp) {
        return;
      }
      const delay = sessionExpiryTimeoutMs(exp * 1000);
      if (delay === 0) {
        markSessionExpired();
        this.props.logout();
        return;
      }
      this.timer = setTimeout(() => {
        const remaining = exp * 1000 - Date.now();
        if (remaining <= 0) {
          markSessionExpired();
          this.props.logout();
          return;
        }
        this.arm();
      }, delay);
    } catch (err) {
      // ignore invalid tokens
    }
  };

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  token: state.global && state.global.auth ? state.global.auth.token : null,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SessionExpiryWatcher);
